import { FC, useMemo, type JSX } from 'react';

import PopupMenu from '../popupMenu/PopupMenu';

import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  anchor: any;
  isOpen: boolean;
  quickActions: {
    actionName: string;
    actionBehaviour: (recordId: any) => void;
    isActionProcessing?: boolean;
  }[];
  onClose: () => void;
  recordId: any;
  renderDisabledIfNoActions?: boolean;
};
const QuickAction: FC<Props> = ({
  anchor,
  isOpen,
  quickActions,
  onClose,
  recordId,
  renderDisabledIfNoActions = false,
}: Props): JSX.Element => {
  const popupMenuOptions = useMemo(() => {
    return quickActions.map((quickAction) => {
      return {
        name: quickAction.actionName,
        onClick: () => {
          quickAction.actionBehaviour(recordId);
          onClose();
        },
        isProcessing: quickAction.isActionProcessing || false,
      };
    });
  }, [quickActions, recordId, onClose]);

  if (!!quickActions.length || renderDisabledIfNoActions) {
    return (
      <>
        <UntitledIcon name="dots-vertical.3" />
        {!!quickActions.length && (
          <PopupMenu
            options={popupMenuOptions}
            isOpen={isOpen}
            onClose={onClose}
            anchorElement={anchor.current}
          />
        )}
      </>
    );
  } else {
    return <></>;
  }
};

export default QuickAction;
